define(['jquery', 'jquery.cookie'], function($) {
    /**
     * Sprawdza, czy ciasteczka zostały zaakceptowane.
     * Wyświetla html, jeżeli brak akceptacji.
     *
     * @param Object options
     * - message : informacja o ciasteczkach
     * - buttonText : tekst na buttonie akceptującym ciasteczka
     * - buttonClass
     * - containerClass
     * - rowClass
     * - cookieName : nazwa cookie
     * - expire : czas życia cookie
     */
    var cookieInfo = function(options) {
        var _options = {};
        var _defaults = {
            message : '',
            buttonText : 'OK',
            buttonClass : '',
            containerClass : 'container',
            rowClass : 'cookie-info',
            cookieName : 'cookiesPolicyAccepted',
            expire : 365*30 // 30lat
        };
        var _cookieAlert = null;

        _options = $.extend({}, _defaults, options);

        this.init = function() {
            var cookiesPolicyAccepted = $.cookie(_options.cookieName);

            if(undefined != cookiesPolicyAccepted || 'true' == cookiesPolicyAccepted) {
                return;
            }

            this.open();
        };

        this.createAlert = function() {
            var _this = this;

            var $messageBox = $('<div/>', {
                class: 'cookie-message',
                html: _options.message
            });

            var $button = $('<button/>', {
                class: _options.buttonClass,
                text: _options.buttonText,
                on: {
                    click: _this.close
                }
            });

            var $buttonBox = $('<div/>', {
                class: 'cookie-button',
            }).append($button);

            var $container = $('<div/>', {
                class: _options.containerClass,
            }).append($messageBox, $buttonBox);

            var $row  = $('<div />', {
                class: _options.rowClass,
            }).append($container).hide();

            return $row;
        };

        this.open = function() {
            if(!_cookieAlert) {
                _cookieAlert = this.createAlert();
            }
            $('body').prepend(_cookieAlert);
            _cookieAlert.slideDown('slow');
        };

        this.close = function() {
            $.cookie(_options.cookieName, true, {expires : _options.expire, path : "/"});

            _cookieAlert.slideUp('fast', function() {
                $(this).remove();
                _cookieAlert = null;
            });
        };

        this.init();
    };

    return cookieInfo;
});